import React from "react";
import { Form, Input } from "antd";
import { LockOutlined } from "@ant-design/icons";

const MFA = () => {
  return (
    <div>
      <Form.Item
        name="mfa_code"
        rules={[
          { required: true, message: "Por favor, ingresa el código MFA" },
          { len: 6, message: "El código debe tener 6 dígitos" },
          {
            pattern: /^[0-9]{6}$/,
            message: "Solo se permiten 6 dígitos numéricos",
          },
        ]}
      >
        <Input
          placeholder="Código MFA (6 dígitos)"
          maxLength={6}
          inputMode="numeric"
          pattern="[0-9]*"
          prefix={<LockOutlined style={{ color: "#1890ff" }} />}
          style={{
            borderRadius: "8px",
            padding: "8px 12px",
          }}
          onKeyPress={(e) => {
            if (!/[0-9]/.test(e.key)) {
              e.preventDefault();
            }
          }}
        />
      </Form.Item>
    </div>
  );
};

export default MFA;
